module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/design-tile-images/design-tile-06-3a5602d263f295fe6a75601c64dd74b6.jpg";